import { Component, OnInit } from '@angular/core';
import { ProgramTypesGUID } from '../../../../models/_enum-collections';
import { PendingReviewCountModel } from '../../../../models/event-count-model';
import { CommonSharedModule } from '../../../common/shared.module';
import { EventDashboardService } from '../../../services/event-dashboard.service';

@Component({
  selector: 'app-events-count',
  templateUrl: './events-count.component.html',
  styleUrls: ['./events-count.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class EventsCountComponent implements OnInit {
  constructor(private eventDashboardService: EventDashboardService) {}

  loading!: boolean;
  engagementCountModel!: PendingReviewCountModel;
  queueTitle = 'Pending Approval';

  ngOnInit() {
    this.loading = true;
    this.eventDashboardService
      .getEngagementsCount(ProgramTypesGUID.Events)
      .subscribe(data => {
        this.engagementCountModel = data;
        this.loading = false;
      });
  }
}
